import React from 'react';
import PavoP2PDeviceSelectDialog from './PavoP2PDeviceSelectDialog';
import PavoRestP2PWaitModal from './modals/PavoRestP2PWaitModal';

/**
 * PrepaidPavoP2PModals
 *
 * QuickSaleScreen'den taşınan PavoPay P2P ile ilgili modal grubu:
 *  - PavoP2PDeviceSelectDialog (cihaz seçimi)
 *  - PavoRestP2PWaitModal (rest-p2p bekleme)
 *
 * Davranış birebir korunur: container koşulsuz render edilir, her modalın
 * orijinal guard'ı (open={...}) bu component içinde aynen yaşar.
 * Props-bag deseni RestaurantFlowModals.tsx ile uyumludur.
 */
interface PrepaidPavoP2PModalsProps {
  // PavoP2PDeviceSelectDialog
  pavoP2pSelectOpen: boolean;
  setPavoP2pSelectOpen: any;
  hookHandlePavoP2pDeviceSelected: any;
  companyId: any;
  activeBranchId: any;
  activePavoPayment: any;
  cancelActivePavoPayment: any;

  // PavoRestP2PWaitModal
  restP2PModalOpen: boolean;
  restP2PStatus: any;
  restP2PMode: any;
  restP2PTotal: any;
  restP2PParts: any;
  restP2PProgress: any;
  restP2PMessage: any;
  restP2PDeviceName: any;
  restP2PErrorCode: any;
  handleRestP2PCancel: any;
  handleRestP2PClose: any;
  handleRestP2PContinueWithoutDevice: any;
}

const PrepaidPavoP2PModals: React.FC<PrepaidPavoP2PModalsProps> = ({
  pavoP2pSelectOpen,
  setPavoP2pSelectOpen,
  hookHandlePavoP2pDeviceSelected,
  companyId,
  activeBranchId,
  activePavoPayment,
  cancelActivePavoPayment,
  restP2PModalOpen,
  restP2PStatus,
  restP2PMode,
  restP2PTotal,
  restP2PParts,
  restP2PProgress,
  restP2PMessage,
  restP2PDeviceName,
  restP2PErrorCode,
  handleRestP2PCancel,
  handleRestP2PClose,
  handleRestP2PContinueWithoutDevice,
}) => {
  return (
    <>
      {/* PavoPay P2P Cihaz Seçim Dialog */}
      <PavoP2PDeviceSelectDialog
        open={pavoP2pSelectOpen}
        onClose={() => setPavoP2pSelectOpen(false)}
        onSelect={hookHandlePavoP2pDeviceSelected}
        companyId={companyId || undefined}
        branchId={activeBranchId || undefined}
        activePavoPayment={activePavoPayment}
        onCancelPayment={cancelActivePavoPayment}
      />

      {/* ✅ Rest-P2P (pavo_rest_p2p) Bekleme Modalı */}
      <PavoRestP2PWaitModal
        open={restP2PModalOpen}
        status={restP2PStatus}
        paymentMode={restP2PMode}
        totalAmount={restP2PTotal}
        parts={restP2PParts}
        progress={restP2PProgress}
        message={restP2PMessage}
        deviceName={restP2PDeviceName}
        errorCode={restP2PErrorCode}
        onCancel={handleRestP2PCancel}
        onClose={handleRestP2PClose}
        onContinueWithoutDevice={handleRestP2PContinueWithoutDevice}
      />
    </>
  );
};

export default PrepaidPavoP2PModals;
